import { GridSortModel } from "@mui/x-data-grid-pro";
import { D2DOrdersFilters } from "../types";
import { D2DOrdersActions, D2DOrdersActionsType } from "./actions";
import { GroupedD2DOrder } from "../utils/orderGrouping";

export type D2DOrdersState = {
  accountId: string;
  d2dOrders: GroupedD2DOrder[];
  isLoading: boolean;
  isTechnicalError: boolean;
  isDownloading: boolean;
  currentPage: number;
  pageRowSize: number;
  totalOrders: number;
  sortModel: GridSortModel;
  filters: D2DOrdersFilters;
};

export const getInitialState = (accountId: string): D2DOrdersState => ({
  accountId,
  d2dOrders: [],
  isLoading: false,
  isTechnicalError: false,
  isDownloading: false,
  currentPage: 1,
  pageRowSize: 10,
  totalOrders: 0,
  sortModel: [],
  filters: {},
});

export const d2dOrdersReducer = (
  state: D2DOrdersState,
  action: D2DOrdersActions
): D2DOrdersState => {
  switch (action.type) {
    case D2DOrdersActionsType.SET_D2D_ORDERS:
      return {
        ...state,
        d2dOrders: action.payload.d2dOrders,
        totalOrders: action.payload.totalOrders,
      };

    case D2DOrdersActionsType.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case D2DOrdersActionsType.SET_IS_TECHNICAL_ERROR:
      return {
        ...state,
        isTechnicalError: action.payload,
      };

    case D2DOrdersActionsType.SET_IS_DOWNLOADING:
      return {
        ...state,
        isDownloading: action.payload,
      };

    case D2DOrdersActionsType.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case D2DOrdersActionsType.SET_PAGE_ROW_SIZE:
      return {
        ...state,
        pageRowSize: action.payload,
      };

    case D2DOrdersActionsType.SET_SORT_MODEL:
      return {
        ...state,
        sortModel: action.payload,
      };

    case D2DOrdersActionsType.SET_FILTER:
      return {
        ...state,
        filters: action.payload,
        currentPage: 1,
      };

    default:
      return state;
  }
};
